import makeApiCall from "./master/axiosIndex";
export const projectsApis = {
  fetchSiteUsers: async (siteId: string | number): Promise<any> => {
    return makeApiCall({
      url: `/buyer/fetchSiteUsers?siteId=${siteId}`,
      method: "get",
    });
  },
  createProject: (data: any): Promise<any> => {
    return makeApiCall({ url: "/project/create", method: "post", data });
  },
  updateProject: (data: any): Promise<any> => {
    return makeApiCall({ url: "/project/update", method: "put", data });
  },
  getProjectList: (data: any): Promise<any> => {
    return makeApiCall({ url: "/project/list", method: "get", params: data });
  },
  getProjectPendingApprovalsList: (data: any): Promise<any> => {
    return makeApiCall({
      url: "/project/pendingApprovalsList",
      method: "get",
      params: data,
    });
  },
  getProjectById: (
    projectId: string,
    derivedProjectStatus: any
  ): Promise<any> => {
    return makeApiCall({
      url: `/project/id/${projectId}`,
      method: "get",
      params: { derivedProjectStatus },
    });
  },
  fetchRateCardDropDown: (): Promise<any> => {
    return makeApiCall({
      url: "/ratecard/dropdown",
      method: "get",
    });
  },
  fetchProjectGroupDropDown: (): Promise<any> => {
    return makeApiCall({
      url: "/project-group/dropdown",
      method: "get",
    });
  },
  fetchSitesUnlinkedProjects: (): Promise<any> => {
    return makeApiCall({
      url: "/project/sitesUnlinkedProjects",
      method: "get",
    });
  },
  fetchProjectCalendarDropDown: (): Promise<any> => {
    return makeApiCall({
      url: "/calendar/dropdown",
      method: "get",
    });
  },
  fetchMaterialBoqDropDown: (siteIds: any): Promise<any> => {
    return makeApiCall({
      url: "/inventory/consumptionTarget/dropdown",
      method: "get",
      params: { siteIds },
    });
  },
  fetchbudgetDropDown: (siteIds: any): Promise<any> => {
    return makeApiCall({
      url: "/budget/dropdown",
      method: "get",
      params: { siteIds },
    });
  },
  deactivateProject: (projectId: any): Promise<any> => {
    return makeApiCall({
      url: `/project/deactivate/${projectId}`,
      method: "patch",
    });
  },
  activateProject: (projectId: any): Promise<any> => {
    return makeApiCall({
      url: `/project/activate/${projectId}`,
      method: "patch",
    });
  },
  fetchProjectUsers: (projectId: any, params?: any): Promise<any> => {
    return makeApiCall({
      url: `/project/users/${projectId}`,
      method: "get",
      params,
    });
  },
  lockProject: (projectId: any): Promise<any> => {
    return makeApiCall({
      url: `/project/lock/${projectId}`,
      method: "patch",
    });
  },
  unLockProject: (projectId: any): Promise<any> => {
    return makeApiCall({
      url: `/project/unlock/${projectId}`,
      method: "patch",
    });
  },
  requestForApproval: (projectId: any): Promise<any> => {
    return makeApiCall({
      url: `/project/requestApprovals/${projectId}`,
      method: "patch",
    });
  },
  closeProject: (projectId: any): Promise<any> => {
    return makeApiCall({
      url: `/project/closure/${projectId}`,
      method: "patch",
    });
  },
  approveProject: (projectId: any): Promise<any> => {
    return makeApiCall({
      url: `/project/approve/${projectId}`,
      method: "patch",
    });
  },
  rejectProject: (data: any): Promise<any> => {
    return makeApiCall({
      url: `/project/reject`,
      method: "patch",
      data,
    });
  },
  getTagsFilterData: (projectStatus: any): Promise<any> => {
    return makeApiCall({
      url: `/project/filters/tags`,
      method: "get",
      params: { projectStatus },
    });
  },
  getGroupsFilterData: (projectStatus: any): Promise<any> => {
    return makeApiCall({
      url: `/project/filters/projectGroups`,
      method: "get",
      params: { projectStatus },
    });
  },
  getOwnersFilterData: (projectStatus: any): Promise<any> => {
    return makeApiCall({
      url: `/project/filters/owners`,
      method: "get",
      params: { projectStatus },
    });
  },
  fetchProjectTags: (projectId: any): Promise<any> => {
    return makeApiCall({
      url: `/project/fetchProjectTags/${projectId}`,
      method: "get",
    });
  },
  fetchProjectBoqs: (projectId: any): Promise<any> => {
    return makeApiCall({
      url: `/project/boqs/${projectId}`,
      method: "get",
    });
  },
  fetchBudgetLines: (projectId: any, params?: any): Promise<any> => {
    return makeApiCall({
      url: `/project/budgetlines/${projectId}`,
      method: "get",
      params,
    });
  },
  fetchStatusFiltersByModule: (moduleName: any): Promise<any> => {
    return makeApiCall({
      url: `/project/allStatus/module/${moduleName}`,
      method: "get",
    });
  },
  archiveProject: (projectId: any): Promise<any> => {
    return makeApiCall({
      url: `/project/archive/${projectId}`,
      method: "patch",
    });
  },
  fetchBuyerById: (id: any): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/buyer/fetchBuyerUserById`,
      params: { id },
    }),
  fetchStatusTimeline: (projectId: number, entityId: number): Promise<any> => {
    return makeApiCall({
      url: `/task/fetchStatusTimelines/${projectId}/Project/${entityId}`,
      method: "get",
    });
  },
  fetchActivityStreamlines: (
    projectId: number,
    entityId: number
  ): Promise<any> => {
    return makeApiCall({
      url: `/activity/fetchActivityStreamlines/${projectId}/Project/${entityId}`,
      method: "get",
    });
  },
  fetchProjectWBS: (projectId: string | number): Promise<any> => {
    return makeApiCall({
      url: `/project/wbs/${projectId}`,
      method: "get",
    });
  },
  uploadWBS: (data: any): Promise<any> =>
    makeApiCall({ url: "/project/upload/wbs", method: "post", data }),
  fetchProjectRolesWithUsers: (projectId: number): Promise<any> => {
    return makeApiCall({
      url: `/project/roles/${projectId}`,
      method: "get",
    });
  },
};
